<template>
  <a-modal
    :title="'AI變裝'"
    v-model="localValue"
    :destroyOnClose="true"
    :centered="true"
    :maskClosable="false"
    :width="680"
    :footer="null"
    @cancel="handleCancel"
  >
    <p class="title" align="middle">生成圖片，預計每張圖片需要5分鐘。</p>
    <a-row>
      <a-col class="col">
        <p class="title">原圖</p>
        <img
          :src="sceneObject.thumb_path"
          alt="AITutorialLeft"
          class="img"
        />
      </a-col>
    </a-row>
    <a-row>
      <a-col class="col">
        <p class="title">請選擇風格</p>
        <div class="style-area">
          <div @click="scroll('styleList', -1)">
            <a-icon
              type="left"
              :class="[{ 'icon-disabled': isLeftDisabled }, 'icon']"
            />
          </div>
          <ul class="style-list" ref="styleList">
            <li
              v-for="item in style"
              :key="item.id"
              class="list-item"
              @click="selectStyle(item.id)"
            >
              <img
                :src="item.image_url"
                alt=""
                :class="[{ 'active-img': item.id == selectStyleID }, 'img']"
              />
              <p
                :class="[
                  { 'active-name': item.id == selectStyleID },
                  'list-name',
                ]"
              >
                {{ item.style_name }}
              </p>
            </li>
          </ul>
          <div @click="scroll('styleList', 1)">
            <a-icon
              type="right"
              :class="[{ 'icon-disabled': isRightDisabled }, 'icon']"
            />
          </div>
        </div>
      </a-col>
    </a-row>
    <a-row>
      <a-col class="col room-area">
        <span class="roomCategory">{{ '空間類型' }}</span>
        <ul class="room-list">
          <li
            v-for="item in room"
            :key="item.id"
            class="list-item"
            @click="selectRoom(item.id)"
          >
            <button :class="[{ 'active-btn': item.id == selectRoomID }, 'btn']">
              {{ item.name }}
            </button>
          </li>
        </ul>
      </a-col>
    </a-row>
    <a-row>
      <a-col class="col">
        <a-checkbox v-model="isAddToTongPing" @change="onChange">
          加入對比圖
        </a-checkbox>
        <span class="info">{{ '(勾選後會將生成好的圖片與原圖進行對比)' }}</span>
      </a-col>
    </a-row>
    <a-row>
      <a-col class="col" align="middle">
        <a-button type="primary" @click="handleTriggerGenerate">生成</a-button>
      </a-col>
    </a-row>
  </a-modal>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      require: true,
    },
    vrbase: {
      type: Object,
      require: true,
    },
    AITransformSceneID: {
      type: String,
      require: true,
    },
    handleGenerate: {
      type: Function,
      require: true,
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
  data() {
    return {
      sceneObject: {},
      selectStyleID: 0,
      selectRoomID: 0,
      // icon顏色辨識
      isLeftDisabled: false,
      isRightDisabled: false,
      isAddToTongPing: false,
      style: [
        {
          id: 0,
          style_name: '侘寂風',
          image_url: 'https://s3-fdi.s3.ap-southeast-1.amazonaws.com/web//o_1i2959v9t102kbj1gb21v0b1qeo4k.jpg',
        },
        {
          id: 1,
          style_name: '工業風',
          image_url: 'https://s3-fdi.s3.ap-southeast-1.amazonaws.com/web//o_1i5mntba81dno4kj1se2t4i1md88.png',
        },
        {
          id: 2,
          style_name: '歐式經典',
          image_url: 'https://s3-fdi.s3.ap-southeast-1.amazonaws.com/web//o_1i5mobjgcqg518r1154e10id16e211.png',
        },
        {
          id: 3,
          style_name: '歐式簡約',
          image_url: 'https://s3-fdi.s3.ap-southeast-1.amazonaws.com/web//o_1ibth33vr1u7q1enm174lq26v9f8.png',
        },
        {
          id: 4,
          style_name: '現代禪風',
          image_url: 'https://s3-fdi.s3.ap-southeast-1.amazonaws.com/web//o_1i295u1hv3231ee8qhs18us1jmn61.jpg',
        },
      ],
      room: [
        {
          id: 0,
          name: '臥室',
        },
        {
          id: 1,
          name: '客廳',
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      const styleList = this.$refs.styleList;
      styleList.addEventListener('wheel', (event) =>
        this.handleScroll(event, 'styleList')
      );

      // 檢查滾動位置
      this.updateScrollButtons();
      // 更新按鈕狀態
      styleList.addEventListener('scroll', this.updateScrollButtons);
    });

    this.sceneObject = this.vrbase.scenes[this.AITransformSceneID];
    console.log('sceneObject:', this.sceneObject);
  },
  methods: {
    handleScroll(event, listName) {
      // 禁止垂直滾動
      event.preventDefault();
      // 計算滾動方向，並根據需要調整水平滾動位置
      const delta = event.deltaY || event.detail || event.wheelDelta;
      const direction = delta > 0 ? 1 : -1;
      this.$refs[listName].scrollLeft += direction * 100; // 調整滾動速度
    },
    scroll(listName, direction) {
      this.$refs.styleList.scrollLeft += direction * 50; // 調整滾動距離
    },
    updateScrollButtons() {
      const styleList = this.$refs.styleList;
      this.isLeftDisabled = styleList.scrollLeft === 0;
      this.isRightDisabled =
        styleList.scrollLeft + styleList.clientWidth >= styleList.scrollWidth;
    },
    handleCancel() {
      this.localValue = false;
    },
    selectStyle(id) {
      this.selectStyleID = id;
    },
    selectRoom(id) {
      this.selectRoomID = id;
    },
    onChange() {
      console.log(`isAddToTongPing = ${this.isAddToTongPing}`,this.AITransformSceneID);
    },
    handleTriggerGenerate() {
      this.localValue = false;
      this.handleGenerate(
        this.AITransformSceneID, 
        this.selectStyleID, 
        this.selectRoomID,
        this.isAddToTongPing
      );
    },
  },
};
</script>
<style lang="less" scoped>
ul,
p {
  margin-bottom: 0;
}
.col {
  user-select: none;
  margin-top: 20px;
  .title {
    margin-bottom: 10px;
  }
  .img {
    width: 100%;
    max-height: 315px;
    object-fit: contain;
    aspect-ratio: 1;
  }
}
.style-area {
  display: flex;
  align-items: center;
  gap: 30px;
  margin: -5px 0;
  user-select: none;
  .style-list {
    display: flex;
    gap: 20px;
    width: 100%;
    overflow-x: auto;
    scrollbar-width: auto;
    padding: 5px;
    &::-webkit-scrollbar {
      height: 15px;
      background-color: #f1f1f1;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 0;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 0;
      border: 2px solid #f1f1f1;
      background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }

  .icon {
    padding: 7px;
    background-color: #015c61;
    border-radius: 50%;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
  }
  .icon-disabled {
    background-color: #0000004d;
    cursor: not-allowed;
  }
}
.list-item {
  min-width: 80px;
  cursor: pointer;
  text-align: center;
  text-wrap: nowrap;
  .img {
    height: 80px;
    border-radius: 50%;
    object-fit: cover;
    aspect-ratio: 1;
    margin-bottom: 7px;
  }
  .active-img {
    outline: 2px solid #015c61;
  }
  .list-name {
    text-align: center;
  }
  .active-name {
    color: #015c61;
  }
}
.room-area {
  display: flex;
  align-items: center;
  gap: 15px;
}
.roomCategory {
  width: fit-content;
}
.room-list {
  flex: 1;
  display: flex;
  gap: 10px;

  > .list-item {
    min-width: 60px;
  }
}

.btn {
  padding: 10px 16px;
  font-size: 14px;
  color: #a7a7a7;
  border: 1px solid #a7a7a7;
  border-radius: 50px;
  background-color: #fff;
  cursor: pointer;
}
.active-btn {
  color: #015c61;
  border: 1px solid #015c61;
}
.info {
  color: #a7a7a7;
}
</style>
